<template>
    <div
        id="Info"
        :class="activeName == '1' ? 'Info-f' : ''"
    >
        <div class="login-top">
            <!-- <img src="@/assets/images/icon/logo.png" class="login-logo"> -->
            老年大学信息采集
        </div>
        <div class="login-box">
            <el-tabs
                class="main_tabs"
                v-model.trim="activeName"
                type="border-card"
            >
                <el-tab-pane
                    label="第一步，填写身份证信息"
                    name="1"
                    v-if="activeName == '1'"
                >
                    <el-form
                        :model="form"
                        ref="form"
                        class="formarea"
                    >
                        <el-form-item
                            label-width="64px"
                            label="身份证"
                        >
                            <el-input
                                placeholder="请输入身份证"
                                type="text"
                                v-model.trim="userpwd"
                                :prefix-icon="iconpwd"
                                @focus="changeIcon(1, 'el-icon-pwd_sel')"
                                @blur="changeIcon(1, 'el-icon-pwd')"
                                @input="checkLogin()"
                                clearable
                                style="margin-bottom: 20px"
                                @keyup.enter.native="userLogin(1)"
                            ></el-input>
                        </el-form-item>
                        <el-form-item
                            label-width="64px"
                            label="姓名"
                        >
                            <el-input
                                placeholder="请输入姓名"
                                v-model.trim="username"
                                :prefix-icon="iconuser"
                                @focus="changeIcon(0, 'el-icon-user_sel')"
                                @blur="changeIcon(0, 'el-icon-user')"
                                @input="checkLogin()"
                                clearable
                                style="margin-bottom: 20px"
                                @keyup.enter.native="userLogin(1)"
                            ></el-input>
                        </el-form-item>
                    </el-form>
                    <div class="button-box">
                        <el-button
                            type="primary"
                            :disabled="checklogin"
                            @click="userLogin()"
                        >
                            下一步
                            <i
                                class="el-icon-loading"
                                v-if="loading"
                            ></i>
                        </el-button>
                    </div>
                </el-tab-pane>

                <el-tab-pane
                    label="第二步，完善个人资料"
                    name="2"
                    v-if="activeName == '2'"
                >
                    <el-form
                        :model="applyForm"
                        ref="applyForm"
                        label-width="150px"
                        class="two"
                    >
                        <el-row :gutter="30">
                            <el-col :span="20">
                                <el-col
                                    :span="8"
                                    v-for="(item, index) in config"
                                    :key="index"
                                    style="position: relative"
                                >
                                    <!-- <span v-if="item.mustFill" style="position: absolute;left: 100px;top:13px;color:#f56c6c">*</span>  -->
                                    <el-form-item
                                        :label="item.note"
                                        :prop="item.name"
                                        v-if="item.type == '2'"
                                        :class="
                                            item.mustFill ? 'is-required' : ''
                                        "
                                    >
                                        <div v-if="
                                                item.name == 'homeLinkMan' ||
                                                item.name ==
                                                    'homeLinkManPhone' ||
                                                item.name == 'homeTel'
                                            ">
                                            <p v-if="isedit">
                                                {{
                                                    applyForm[
                                                        item.name + "hide"
                                                    ]
                                                }}
                                            </p>
                                            <el-input
                                                v-else
                                                v-model.trim="
                                                    applyForm[
                                                        item.name + 'hide'
                                                    ]
                                                "
                                                :placeholder="
                                                    '请输入' + item.note
                                                "
                                                @focus="inputfoucus(item.name)"
                                                @change="inputchange(item.name)"
                                            ></el-input>
                                        </div>
                                        <div v-else-if="item.name == 'idCard'">
                                            <p v-if="isedit">
                                                {{
                                                    applyForm[
                                                        item.name + "hide"
                                                    ]
                                                }}
                                            </p>
                                            <el-input
                                                v-else
                                                v-model.trim="
                                                    applyForm[
                                                        item.name + 'hide'
                                                    ]
                                                "
                                                :placeholder="
                                                    '请输入' + item.note
                                                "
                                                :disabled="true"
                                            ></el-input>
                                        </div>
                                        <div v-else-if="item.name == 'name'">
                                            <p v-if="isedit">
                                                {{ applyForm[item.name] }}
                                            </p>
                                            <el-input
                                                v-else
                                                v-model.trim="
                                                    applyForm[item.name]
                                                "
                                                :placeholder="
                                                    '请输入' + item.note
                                                "
                                                :disabled="true"
                                            ></el-input>
                                        </div>
                                        <div v-else>
                                            <p v-if="isedit">
                                                {{ applyForm[item.name] }}
                                            </p>
                                            <el-input
                                                v-else
                                                v-model.trim="
                                                    applyForm[item.name]
                                                "
                                                clearable
                                                :placeholder="
                                                    '请输入' + item.note
                                                "
                                            ></el-input>
                                        </div>
                                    </el-form-item>

                                    <el-form-item
                                        :label="item.note"
                                        :prop="item.name"
                                        v-if="item.type == '3'"
                                        width="150px"
                                    >
                                        <p v-if="isedit">
                                            {{ applyForm[item.name] }}
                                        </p>
                                        <el-date-picker
                                            v-else
                                            v-model="applyForm[item.name]"
                                            type="date"
                                            :placeholder="'请输入' + item.note"
                                            format="yyyy-MM-dd"
                                            value-format="yyyy-MM-dd"
                                            clearable
                                            :editable="false"
                                            :picker-options="pickerOptions1"
                                        ></el-date-picker>
                                    </el-form-item>
                                    <el-form-item
                                        :label="item.note"
                                        :prop="item.name"
                                        v-if="item.type == '1'"
                                    >
                                        <p v-if="isedit">
                                            {{
                                                gettext(
                                                    applyForm[item.name],
                                                    item.code
                                                )
                                            }}
                                        </p>
                                        <el-select
                                            v-else
                                            v-model="applyForm[item.name]"
                                            clearable
                                            filterable
                                            :placeholder="'请输入' + item.note"
                                        >
                                            <el-option
                                                v-for="item in dictionary[
                                                    item.code
                                                ]"
                                                :key="item.codeKey"
                                                :label="item.codeValue"
                                                :value="item.codeKey"
                                            ></el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                            </el-col>
                        </el-row>

                        <el-row
                            type="flex"
                            justify="center"
                            style="margin: 20px 0"
                        >
                            <el-button
                                type="default"
                                @click="prev"
                            >上一步</el-button>
                            <el-button
                                type="primary"
                                @click="submitForm"
                            >下一步</el-button>
                        </el-row>
                    </el-form>
                </el-tab-pane>
                <el-tab-pane
                    label="第三步，选择想要学习的课程"
                    name="3"
                    v-if="activeName == '3'"
                >
                    <div
                        class="button-row mb10"
                        style="font-size: 16px"
                    >
                        当前筛选：
                        <el-tag
                            v-for="tag in tags"
                            :key="tag.name"
                            closable
                            @close="handleClose(tag)"
                            :type="tag.type"
                        >
                            {{ tag.name }}
                        </el-tag>
                        <el-input
                            v-model="query.name"
                            class="w200 right"
                            placeholder="请输入您要选择课程"
                            clearable
                            @change="handleQuery"
                            prefix-icon="el-icon-search"
                        ></el-input>
                    </div>
                    <el-form
                        :model="query"
                        ref="query"
                        class="formareas"
                    >
                        <el-row :gutter="10">
                            <el-col :span="24">
                                <el-form-item
                                    label="校区:"
                                    prop="name"
                                    style="font-size: 24px"
                                    label-width="96px"
                                >
                                    <el-radio-group
                                        v-model="query.campusId"
                                        @change="perChange1"
                                    >
                                        <el-radio-button
                                            v-for="(
                                                item, index
                                            ) in dictionary.campusData"
                                            :label="item.id"
                                            :key="index"
                                        >{{ item.name }}</el-radio-button>
                                    </el-radio-group>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row
                            :gutter="10"
                            v-if="dictionary.campusData.length > 0"
                        >
                            <el-col :span="24">
                                <el-form-item
                                    label="系/专业:"
                                    prop="name"
                                    style="font-size: 24px"
                                    label-width="96px"
                                >
                                    <el-radio-group
                                        v-model="query.specialtyId"
                                        @change="perChange2"
                                    >
                                        <el-radio-button
                                            v-for="(
                                                item, index
                                            ) in dictionary.majorData"
                                            :label="item.id"
                                            :key="index"
                                        >{{ item.name }}</el-radio-button>
                                    </el-radio-group>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-form>
                    <el-table
                        :data="tableData"
                        ref="dataTable"
                        @row-click="rowClick"
                        @select="handlerow"
                    >
                        <el-table-column type="selection"></el-table-column>
                        <el-table-column
                            label="课程"
                            prop="name"
                            min-width="120px"
                        >
                        </el-table-column>
                        <el-table-column
                            label="所属专业/系"
                            prop="specialtyName"
                        ></el-table-column>
                        <el-table-column
                            label="所属校区"
                            prop="campusName"
                            min-width="50px"
                        >
                        </el-table-column>
                    </el-table>
                    <!-- <div class="wrap_footer clearfix">
           
            <div class="right">
              <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="pageIndex"
                :page-sizes="[5, 10, 15, 20]"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total">
              </el-pagination>
            </div>
          </div> -->
                    <el-form
                        :model="choosequery"
                        ref="choosequery"
                        class="formareass"
                    >
                        <el-row :gutter="10">
                            <el-col :span="24">
                                <el-form-item
                                    label="没有满意的课程？您可在下方输入框中填写您期望就读的课程"
                                    prop="name"
                                    style="font-size: 24px"
                                >
                                    <el-input
                                        type="textarea"
                                        placeholder="请输入备注"
                                        v-model.trim="choosequery.memo"
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-form>
                    <el-row
                        type="flex"
                        justify="center"
                        style="margin-top: 20px"
                    >
                        <el-button
                            type="default"
                            @click="toIndex"
                        >上一页</el-button>
                        <el-button
                            type="primary"
                            @click="subInfo"
                        >提交</el-button>
                    </el-row>
                </el-tab-pane>
                <el-tab-pane
                    label="第四步，信息采集结果提示"
                    name="4"
                    v-if="activeName == '4'"
                >
                    <div class="success-main">
                        <div>
                            <img src="@/assets/images/icon/ico7.png" />
                        </div>
                        <div class="success-info">
                            <div>{{ name }}您好</div>
                            <div>系统已为您信息采集成功</div>
                        </div>
                    </div>
                </el-tab-pane>
            </el-tabs>
        </div>
    </div>
</template>

<script>
export default {
    name: "",
    data() {
        return {
            config: [],
            dictionary: {
                courseData: [],
                majorData: [],
                campusData: [],
                classtype: [],
            },
            tableData: [],
            tags: [],
            name: "",
            isinit: true,
            query: {
                type: "5",
                campusId: "",
                name: "",
                planType: "1",
                isPreordain: true,
                specialtyId: "",
                courseId: "",
                week: "",
                newFlag: "",
                pageIndex: 1,
                pageSize: 5,
            },
            campusName: "",
            choosequery: {
                termId: "",
                courseIds: [],
                memo: "",
                campusId: "",
                planId: "",
            },

            multipleSelection: [],
            login: "登录",
            activeName: "1",
            username: null,
            userpwd: null,
            iconuser: "el-icon-user",
            iconpwd: "el-icon-pwd",
            iconinvite: "el-icon-invite",
            checklogin: true,
            applyForm: {
                photourl: "",
                name: "",
            },
            loading: false,

            pickerOptions1: {
                disabledDate: (time) => {
                    let me = this;
                    return time.getTime() > Date.now();
                },
            },
            getRowKey(row) {
                return row.id;
            },
            compCode: null,
        };
    },
    mounted: async function () {
        const me = this;
        if (window.sessionStorage.getItem("info")) {
            me.activeName = window.sessionStorage.getItem("info");
        }
        if (me.activeName == "2") {
            me.queryConfig();
        }
        if (me.activeName == "3") {
            me.isinit = true;
            me.query = {
                type: "1",
                campusId: "",
                name: "",
                planType: "1",
                isPreordain: true,
                specialtyId: "",
                courseId: "",
                week: "",
                newFlag: "",
                pageIndex: 1,
                pageSize: 5,
            };
            me.select();
        }
        let myDate = new Date();
        this.year = myDate.getFullYear();
        // me.init();
        let host =
            window.location.host == "localhost"
                ? "120.77.227.46"
                : window.location.host;
        await me.getCompCode(host);
    },
    methods: {
        toIndex() {
            this.activeName = "2";
            window.sessionStorage.setItem("info", "2");
        },
        handleClose(tag) {
            this.tags.splice(this.tags.indexOf(tag), this.tags.length);
            if (tag.code == "1") {
                this.query = {
                    type: "1",
                    campusId: "",
                    name: "",
                    specialtyId: "",
                    courseId: "",

                    isPreordain: true,
                    week: "",
                    newFlag: "",
                    planType: "1",
                    pageIndex: 1,
                    pageSize: 5,
                };
                this.tableData = [];
                //  this.select();
                this.dictionary.majorData = [];
            } else if (tag.code == "2") {
                this.query.type = "3";
                this.query.courseId = "";
                this.query.specialtyId = "";
                this.dictionary.courseData = [];
                this.select();
            } else if (tag.code == "3") {
                this.query.type = "4";
                this.query.courseId = "";
                this.select();
            }
        },
        async subInfo() {
            let me = this;

            if (me.multipleSelection.length == "0" && !me.choosequery.memo) {
                me.$message({
                    message: "请选择课程或填写期望课程",
                    type: "warning",
                });
                return;
            }
            this.multipleSelection.forEach((row) => {
                me.choosequery.courseIds.push(row.id);
            });
            let param = me.choosequery;
            let res = await me.$userService.pushPreordainRecord(param);
            if (res && res["success"]) {
                me.$alert("系统已为您信息采集成功", me.name + "您好：", {
                    confirmButtonText: "确定",
                    showClose: false,
                    callback: (action) => {
                        if (action == "confirm") {
                            me.activeName = "1";
                            me.multipleSelection = [];
                            me.choosequery.courseIds = [];
                            me.choosequery.memo = "";
                            me.multipleSelection.forEach((row) => {
                                me.$refs.dataTable.toggleRowSelection(
                                    row,
                                    false
                                );
                            });
                            window.sessionStorage.setItem("info", "1");
                        }
                    },
                });

                //   me.$message({
                //   message: res.content,
                //   type: 'success',
                //   duration:'500',
                //   onClose:function(){
                //         me.choosequery.courseIds=[];
                //         me.choosequery.memo='';
                //         me.multipleSelection.forEach(row => {
                //             me.$refs.dataTable.toggleRowSelection(row, false);
                //       });
                //   //  me.activeName='4';
                //   //  window.sessionStorage.setItem("info", '4');
                //   }
                // });
            } else {
                me.choosequery.courseIds = [];
            }
        },
        //  处理表格勾选
        handlerow(selection, row) {
            let me = this;
            me.multipleSelection = [];

            me.multipleSelection = selection;
        },
        rowClick(row) {
            if (this.multipleSelection.indexOf(row) == "-1") {
                this.multipleSelection.push(row);
            } else {
                this.multipleSelection.splice(
                    this.multipleSelection.indexOf(row),
                    1
                );
            }

            this.$refs.dataTable.toggleRowSelection(row);
        },
        handleQuery() {
            this.select();
        },
        // 处理每页显示数量
        handleSizeChange(val) {
            this.query.pageSize = val;
            this.select();
        },
        // 处理翻页
        handleCurrentChange(val) {
            this.query.pageIndex = val;
            this.select();
        },
        async select() {
            let me = this;
            let param = me.query;
            let temData = [],
                intemData = [];

            let res = await me.$userService.select(param);

            if (res && res["success"]) {
                if (param.type == "1") {
                    me.dictionary.campusData = res.content.data;
                    if (me.isinit) {
                        me.tags = [];
                        me.query.campusId = res.content.campusId;
                        me.choosequery.campusId = res.content.campusId;
                        me.campusName = me.dictionary.campusData[0].name;
                        me.tags.push({
                            name: me.dictionary.campusData[0].name,
                            type: "",
                            code: "1",
                            id: this.dictionary.campusData[0].id,
                        });
                    }
                    // me.choosequery.termId=res.content.term.id;
                    me.query.type = "3";
                    me.select();
                    me.isinit = false;
                } else if (param.type == "3") {
                    me.dictionary.majorData = res.content.data;
                    me.dictionary.courseData = [];
                    me.query.type = "4";
                    me.select();
                } else if (param.type == "4") {
                    res.content.data.forEach((item) => {
                        item.campusName = me.campusName;
                    });
                    me.tableData = res.content.data;

                    if (
                        me.multipleSelection &&
                        me.multipleSelection.length > 0
                    ) {
                        me.tableData.forEach((item) => {
                            me.multipleSelection.forEach((items) => {
                                if (item.id == items.id) {
                                    me.$nextTick(() => {
                                        me.$refs.dataTable.toggleRowSelection(
                                            item,
                                            true
                                        );
                                    });
                                }
                            });
                        });
                    }
                    me.total = res.content.data.total;
                    me.query.pageIndex = res.content.data.page;
                }
            }
        },
        perChange1(item) {
            for (var i = 0; i < this.dictionary.campusData.length; i++) {
                for (var j = 0; j < this.tags.length; j++) {
                    if (
                        this.tags[j].name == this.dictionary.campusData[i].name
                    ) {
                        this.tags.splice(j, 1);
                        j = j - 1;
                    }
                }

                if (this.dictionary.campusData[i].id == item) {
                    this.choosequery.campusId = this.dictionary.campusData[
                        i
                    ].id;
                    this.tags.splice(0, this.tags.length);
                    this.tags.splice(0, 0, {
                        name: this.dictionary.campusData[i].name,
                        type: "",
                        code: "1",
                        id: this.dictionary.campusData[i].id,
                    });
                }
            }
            this.query.specialtyId = "";
            this.query.courseId = "";
            this.query.type = "3";
            this.select();
        },
        perChange2(item) {
            for (var i = 0; i < this.dictionary.majorData.length; i++) {
                for (var j = 0; j < this.tags.length; j++) {
                    if (
                        this.tags[j].name == this.dictionary.majorData[i].name
                    ) {
                        this.tags.splice(j, 1);
                        j = j - 1;
                    }
                }
                if (this.dictionary.majorData[i].id == item) {
                    this.tags.splice(1, this.tags.length);
                    this.tags.splice(1, 0, {
                        name: this.dictionary.majorData[i].name,
                        type: "",
                        code: "2",
                        id: this.dictionary.majorData[i].id,
                    });
                }
            }
            this.query.type = "4";
            this.query.courseId = "";
            this.select();
        },
        changeIcon(type, text) {
            let me = this;
            switch (type) {
                case 0:
                    me.iconuser = text;
                    break;
                case 1:
                    me.iconpwd = text;
                    break;
                case 2:
                    me.iconinvite = text;
                    break;
            }
        },

        checkLogin() {
            let me = this;
            if (
                me.username &&
                me.username.length > 0 &&
                me.userpwd &&
                me.userpwd.length > 0
            ) {
                me.checklogin = false;
            } else {
                me.checklogin = true;
            }
        },
        async getCompCode(url) {
            console.log(url);
            let res = await this.$userService.getCompCode({ realmName: url });
            if (res && res["success"]) {
                this.compCode = res.content.code;
            }
        },
        userLogin: async function () {
            let me = this;
            if (!me.checklogin) {
                me.loading = true;
                me.checklogin = true;
                let param = {};
                param.name = me.username;
                me.name = me.username;
                param.idCard = me.userpwd;
                param.compCode = me.compCode;
                let res = await me.$userService.loginByPreirdain(param);
                if (res && res["success"]) {
                    let userinfo = res.content.data;
                    me.loading = true;
                    me.checklogin = true;

                    window.sessionStorage.setItem(
                        "userinfo",
                        JSON.stringify(userinfo)
                    );
                    me.goToPath(res["content"].tokenData);
                } else {
                    me.loading = false;
                    me.checklogin = false;
                    me.checkLogin();
                }
            }
        },
        async goToPath(token) {
            let me = this;
            await me.$httpServe.setToken(token);
            let res = await me.$userService.checkIsPush();
            if (res && res["success"]) {
                if (res.content) {
                    this.$confirm(
                        "您已经完成信息采集，请勿重复采集",
                        me.username + "您好：",
                        {
                            confirmButtonText: "重置信息采集",
                            cancelButtonText: "取消",
                            showCancelButton: false,
                            type: "warning",
                        }
                    )
                        .then(() => {
                            me.cleanPreordainRecord();
                        })
                        .catch(() => {
                            me.loading = false;
                            me.checklogin = false;
                        });
                } else {
                    me.ispersonInfo();
                }
            } else {
                me.loading = false;
                me.checklogin = false;
            }
        },
        async cleanPreordainRecord() {
            let me = this;
            let rs = await me.$userService.cleanPreordainRecord();
            if (rs && rs["success"]) {
                me.$message({
                    message: "重置成功，请重新采集信息",
                    type: "success",
                    duration: "500",
                    onClose: function () {
                        me.ispersonInfo();
                        me.username = "";
                        me.idCard = "";
                        me.loading = false;
                        me.checklogin = false;
                    },
                });
            }
        },
        async ispersonInfo() {
            let me = this;
            let rs = await me.$userService.checkNeedAuth();
            if (rs && rs["success"]) {
                if (rs["content"].studentInfo.allFlag) {
                    me.activeName = "3";
                    window.sessionStorage.setItem("info", "3");
                    me.isinit = true;
                    me.query = {
                        type: "1",
                        campusId: "",
                        name: "",
                        isPreordain: true,
                        planType: "1",
                        specialtyId: "",
                        courseId: "",
                        week: "",
                        newFlag: "",
                        pageIndex: 1,
                        pageSize: 5,
                    };
                    me.select();
                } else {
                    me.activeName = "2";
                    window.sessionStorage.setItem("info", "2");
                    me.queryConfig();
                }
            }
        },
        async queryStudentById() {
            let me = this,
                param = {
                    id: "",
                };
            me.applyForm = {};
            let userinfo = window.sessionStorage.getItem("userinfo");
            userinfo = JSON.parse(userinfo);
            param.id = userinfo.id;
            let res = await me.$team.queryStudentById(param);
            if (res && res["success"]) {
                let userinfo = res.content;
                window.sessionStorage.setItem(
                    "userinfo",
                    JSON.stringify(userinfo)
                );
                me.config.forEach(function (item, index) {
                    if (
                        item.name == "homeLinkMan" ||
                        item.name == "homeLinkManPhone" ||
                        item.name == "homeTel" ||
                        item.name == "idCard"
                    ) {
                        item.hidden = item.name + "hide";
                        if (res.content[item.name]) {
                            let str = me.hidden(res.content[item.name], 3, 4);
                            me.$set(me.applyForm, item.hidden, str);
                        } else {
                            let str = "";
                            me.$set(me.applyForm, item.hidden, str);
                        }
                    }
                    if (item.type == "1") {
                        item.values = item.name + "code";
                        me.queryCodeInfoByCode(item.code);
                        me.applyForm[item.values] = "";
                    }
                    me.imageUrl = res.content.photoImg;
                    me.$set(me.applyForm, item.name, res.content[item.name]);
                });
            }
        },
        //  根据类型查询字典码
        async queryCodeInfoByCode(code) {
            let me = this;
            //  查询学员信息
            let param = {
                pageIndex: 1,
                pageSize: 10,
            };
            if (code == "nation") {
                let nation = await me.$userService.queryAll();
                if (nation && nation.success) {
                    let key = code;
                    me.$set(me.dictionary, key, nation.content.records);
                    // me.dictionary[key]= nation.content.records;
                }
            } else {
                let sex = await me.$userService.queryCodeInfoByCode(code);
                if (sex && sex.success) {
                    let key = code;
                    me.$set(me.dictionary, key, sex.content.records);
                    // me.dictionary[key]= sex.content.records;
                }
            }
        },
        async queryConfig() {
            let me = this,
                param = {
                    name: "",
                    pageIndex: 1,
                    pageSize: 999,
                };
            let res = await me.$team.queryConfig(param);
            if (res && res["success"]) {
                me.config = res.content.records;
                await me.queryStudentById();
            }
        },
        inputfoucus(index) {
            this.applyForm[index + "hide"] = this.applyForm[index];
        },
        inputchange(index) {
            this.applyForm[index] = this.applyForm[index + "hide"];
        },
        hidden: function (str, frontLen, endLen) {
            var len = str.length - frontLen - endLen;
            var xing = "";
            for (var i = 0; i < len; i++) {
                xing += "*";
            }
            return (
                str.substring(0, frontLen) +
                xing +
                str.substring(str.length - endLen)
            );
        },
        prev() {
            this.activeName = "1";
            window.sessionStorage.setItem("info", "1");
        },
        //  提交报名表单
        async submitForm() {
            let me = this,
                can = false;
            for (let i = 0; i < this.config.length; i++) {
                if (this.config[i].mustFill && this.config[i].type == "2") {
                    let text = this.config[i].note;
                    if (me.applyForm[me.config[i].name] == "") {
                        me.$message({
                            message: "请填写报名学员" + text,
                            type: "error",
                        });
                        return;
                    }
                }
                if (i == me.config.length - 1) {
                    can = true;
                }
            }
            if (can) {
                let res = await me.$userService.saveOrUpdateStudent(
                    me.applyForm
                );
                if (res && res.success) {
                    me.$message({
                        message: "保存成功",
                        type: "success",
                        duration: "500",
                        onClose: function () {
                            me.activeName = "3";
                            window.sessionStorage.setItem("info", "3");
                            me.isinit = true;
                            me.query = {
                                type: "1",
                                campusId: "",
                                name: "",
                                planType: "1",
                                specialtyId: "",
                                courseId: "",
                                week: "",
                                newFlag: "",
                                pageIndex: 1,
                                pageSize: 5,
                            };
                            me.select();
                        },
                    });
                }
            }
        },
    },
};
</script>

<style lang="scss">
@import "../../assets/css/login.css";
@import "../../assets/less/global.less";
@import "../../assets/css/icon.css";
@import "../../assets/css/app.css";
.el-icon-successicon {
    width: 16px;
    height: 16px;
    margin-right: 5px;
}
#app {
    background-color: #f2f2f2 !important;
}
.formareas {
    border: 1px solid #e6eaef;
    margin: 20px 0;
    padding: 0 10px;
    .el-row {
        border-bottom: 1px dashed #e6eaef;
        .el-form-item {
            margin: 0px;
        }
    }
    .el-radio-button__inner {
        font-size: 16px;
        border: none !important;
    }
    .el-radio-button__orig-radio:checked + .el-radio-button__inner {
        color: #409eff;
        background-color: #fff;
        box-shadow: none;
    }
}
#Info
    .login-box
    .el-tabs
    .el-tabs__header
    > .el-tabs__nav-wrap
    > .el-tabs__nav-scroll
    > .el-tabs__nav
    .el-tabs__item {
    width: 85%;
}
.el-message-box__message p {
    font-size: 16px;
}
.two {
    .el-col {
        margin-bottom: 20px;
    }
}
.el-form-item {
    margin-bottom: 0px;
}
.success-main {
    display: flex;
    align-items: center;
    margin-top: 20px;
    padding-left: 50px;
}
.success-info {
    font-size: 16px;
    font-weight: bold;
    color: #000;
    text-align: left;
    margin-left: 10px;
}
.Info-f {
    width: 457px;
    height: 418px;
    position: absolute;
    top: 0%;
    left: 0%;
    right: 0%;
    bottom: 0%;
    margin: auto;
    .login-box {
        height: 340px;
    }
}
#Info
    .login-box
    .el-tabs
    .el-tabs__header
    > .el-tabs__nav-wrap
    > .el-tabs__nav-scroll
    > .el-tabs__nav
    .el-tabs__item {
    text-align: left !important;
}
#Info {
    box-sizing: border-box;
    .el-tabs.main_tabs .el-tabs__header .el-tabs__nav {
        background: #fff;
    }
    .el-tabs.main_tabs .el-tabs__header .el-tabs__nav .el-tabs__item.is-active {
        font-weight: normal;
    }
    .bg-login {
        position: fixed;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        z-index: -1;
    }
    .login-top {
        text-align: center;
        font-size: 24px;
        font-weight: bold;
        color: #333333;
        margin-bottom: 20px;
    }
    .login-logo {
        width: 82px;
        height: 51px;
    }

    .login-box {
        background: #fff;
        border-radius: 10px;

        display: flex;
        justify-content: space-between;
        .login-intro {
            height: 100%;
            width: 40%;
            padding: 100px 0;
            div {
                height: 44px;
                line-height: 44px;
                font-size: 20px;
                color: #152237;
                margin: 10px 0;
                text-align: center;
            }
            .intro-ope {
                width: 150px;
                color: #ff8d3c;
                border: 1px solid #ff8d3c;
                margin: 0 auto;
                border-radius: 5px;
            }
        }
        .bg-logo {
            width: auto;
            height: 420px;
            margin: 0px 0 0 100px;
            float: left;
        }
        .el-tabs--border-card {
            border: none;
            background: none;
            box-shadow: none;
        }
        .el-tabs {
            width: 100%;
            padding: 20px;
            .el-tabs__header
                > .el-tabs__nav-wrap
                > .el-tabs__nav-scroll
                > .el-tabs__nav {
                width: 100%;
                .el-tabs__item {
                    width: 50%;
                    text-align: center;
                    margin: 0;
                }
            }
            .el-tabs__content {
                padding: 30px;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/Info/Info.vue